import React, { useEffect, useState } from "react";
import Lenis from "lenis";
import { usePortfolioData } from "../lib/api";
import { AuroraBackground } from "../components/shared/Primitives";
import Loader from "../components/Loader";
import Navbar from "../components/Navbar";
import CommandPalette from "../components/CommandPalette";
import Hero from "../components/sections/Hero";
import KeywordMarquee from "../components/sections/Marquee";
import About from "../components/sections/About";
import Projects from "../components/sections/Projects";
import Skills from "../components/sections/Skills";
import GitHubSection from "../components/sections/GitHubSection";
import Experience from "../components/sections/Experience";
import Blogs from "../components/sections/Blogs";
import TerminalSection from "../components/sections/TerminalSection";
import Testimonials from "../components/sections/Testimonials";
import Contact from "../components/sections/Contact";
import Footer from "../components/sections/Footer";

function CursorGlow() {
    const [pos, setPos] = useState({ x: -100, y: -100 });
    useEffect(() => {
        const move = (e) => setPos({ x: e.clientX, y: e.clientY });
        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, []);
    return (
        <div className="fixed pointer-events-none z-[80] hidden md:block" style={{ left: pos.x, top: pos.y, transform: "translate(-50%,-50%)" }}>
            <div className="w-64 h-64 rounded-full opacity-20" style={{ background: "radial-gradient(circle, #3B82F6, transparent 60%)" }} />
        </div>
    );
}

export default function Home() {
    const data = usePortfolioData();
    const [paletteOpen, setPaletteOpen] = useState(false);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); lenis.destroy(); };
    }, []);

    const { config } = data;

    return (
        <div className="relative noise min-h-screen">
            <Loader />
            <AuroraBackground />
            <CursorGlow />
            <Navbar onOpenPalette={() => setPaletteOpen(true)} />
            <CommandPalette open={paletteOpen} setOpen={setPaletteOpen} config={config} />

            <main className="relative z-10">
                <Hero config={config || {}} />
                <KeywordMarquee />
                <About config={config || {}} achievements={data.achievements} github={data.github} />
                <Projects projects={data.projects} />
                <Skills skills={data.skills} />
                <GitHubSection github={data.github} config={config || {}} />
                <Experience experience={data.experience} education={data.education} certifications={data.certifications} />
                <Blogs blogs={data.blogs} />
                <TerminalSection config={config || {}} />
                <Testimonials testimonials={data.testimonials} />
                <Contact config={config || {}} />
            </main>
            <Footer config={config || {}} />
        </div>
    );
}
